import BaseService from "./Base.Service";

class DocumentService extends BaseService {
    constructor() {
        super("documents")
    }

    async uploadDocument(formData) {
        try {
            const { data } = await this.conn.axios.post(`/documents/upload-document`, formData, { headers: { 'Content-Type': 'multipart/formdata' } });
            return data;
        } catch (err) {
            return this.sendError("Erros foram encontrados ao salvar", false, err);
        }
    }

    async getDocument(filename) {
        try {
            const { data } = await this.conn.axios({
                method: 'GET',
                url: `/documents/get-document?filename=` + filename,
                responseType: 'blob'
            })

            // Em producao (S3) o backend responde com JSON { url } contendo o link
            // assinado em vez do arquivo binario. Detectamos pelo content-type do blob.
            if (data && typeof data.type === 'string' && data.type.includes('application/json')) {
                const text = await data.text();
                return JSON.parse(text);
            }

            return data;
        } catch (err) {
            // Com responseType blob, a mensagem do back não chega: o texto é o do download
            return this.sendError("Erro ao baixar o documento", false, err);
        }
    }
}

export default DocumentService;